// client/src/components/marketer/project/modals/ManagerModal.js
import React, { useEffect, useState } from 'react';
import { API_URL } from '../constants';
import AlertModal from './AlertModal';
import '../../../../styles/marketer/modals/ManagerModal.css';

export default function ManagerModal({ open, onClose, projectId, initialManager, onSaved }) {
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [officeHour, setOfficeHour] = useState('');
  const [saving, setSaving] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    if (open) {
      setPhone(initialManager?.phone || '');
      setEmail(initialManager?.email || '');
      setOfficeHour(initialManager?.officeHour || '');
      setSaving(false);
    }
  }, [open, initialManager]);

  if (!open) return null;

  const save = async () => {
    if (!projectId) return setAlertMessage('먼저 1단계를 저장해주세요.');
    setSaving(true);
    try {
      const body = {
        phone: String(phone ?? ''),
        email: String(email ?? ''),
        officeHour: String(officeHour ?? '')
      };
      const res = await fetch(`${API_URL}/api/marketer/mybiz/projects/${encodeURIComponent(projectId)}/manager`, {
        method: 'PATCH',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const j = await res.json().catch(()=>({}));
      if (!res.ok || !j?.ok) throw new Error(j?.message || '저장 실패');
      onSaved(j.manager || body);
      onClose();
    } catch (e) { setAlertMessage(e.message || '저장 실패'); }
    setSaving(false);
  };

  return (
    <div className="manager-modal mbm-overlay">
      <div className="manager-modal__content mbm">
        <button onClick={onClose} aria-label="close" className="manager-modal__close mbm-close">×</button>

        <div className="manager-modal__header">
          <div className="manager-modal__title mbm-title">광고 프로젝트 담당자 정보를 입력해주세요.(선택)</div>
          <div className="manager-modal__description">(선정된 인플루언서에게만 노출됩니다.)</div>
        </div>

        <div className="manager-modal__form">
          <div className="manager-modal__field">
            <div className="manager-modal__label">연락처</div>
            <input className="manager-modal__input" placeholder="담당자 전화번호를 입력해주세요." value={phone} onChange={e=>setPhone(e.target.value)} />
          </div>
          <div className="manager-modal__field">
            <div className="manager-modal__label">E-mail</div>
            <input className="manager-modal__input" placeholder="Email을 입력해주세요." value={email} onChange={e=>setEmail(e.target.value)} />
          </div>
          <div className="manager-modal__field">
            <div className="manager-modal__label">응답가능시간</div>
            <input className="manager-modal__input" placeholder="응답 가능하신 시간대를 알려주세요." value={officeHour} onChange={e=>setOfficeHour(e.target.value)} />
          </div>
        </div>

        <div className="manager-modal__actions mbm-foot">
          <button type="button" onClick={save} disabled={saving} className={`manager-modal__button manager-modal__button--submit mb-btn mb-btn-primary ${saving ? 'manager-modal__button--disabled' : ''}`}>
            {saving ? '저장 중...' : '입력하기'}
          </button>
        </div>
      </div>

      <AlertModal 
        open={!!alertMessage} 
        onClose={() => setAlertMessage('')} 
        message={alertMessage} 
      />
    </div>
  );
}